import { useState } from "react";
import Cleave from "cleave.js/react";
import { Link, useRouteLoaderData, Form } from "react-router-dom";
//-----------------------------------------------------
import { myAccessOptions } from "./UserForm";
//-----------------------------------------------------
export default function DispatchForm({ 
    keyword
}: {
    keyword: string
}){
    const [user, setUser] = useState(useRouteLoaderData("user") ?? {email: "", firstName: "", middleName: "", lastName: "", phoneNumber: "", background: ""});
    return(
        <Form method = "post">
            <input type = "hidden" name = "keyword" value = {keyword}/>
            <input type = "hidden" name = "dispatch" value = "1"/>
            {Object.entries(myAccessOptions).map(([key, value], index) => 
                <input
                key = {index}
                type = "hidden"
                readOnly
                name = {key}
                value = {key === "assignments"?"yes":value.at(-1)}
            />
            )}
            <div className = "d-flex my-2">
                <label htmlFor = "userEmail" className = "fw-bold me-3 py-2 required-field text-nowrap">Email:</label>
                <input
                    required
                    className = "form-control"
                    type = "email"
                    style = {{flexGrow: 1, textTransform: "lowercase"}}
                    id = "email"
                    name = "userEmail"
                    value = {user.email}
                    onChange = {(e) => setUser({...user, email: e.currentTarget.value})}
                />
            </div>
            <div className = "d-flex my-2">
                <label className = "fw-bold me-3 py-2">Name:</label>
                <input
                    required
                    placeholder = "First Name"
                    className = "form-control me-3"
                    id = "firstName" name = "firstName"
                    value = {user.firstName}
                    onChange = {(e) => setUser({...user, firstName: e.currentTarget.value})}
                />
                <input
                    placeholder = "Middle Name"
                    className = "form-control me-3"
                    id = "middleName" name = "middleName"
                    value = {user.middleName}
                    onChange = {(e) => setUser({...user, middleName: e.currentTarget.value})}
                />
                <input
                    required
                    placeholder = "Last Name"
                    className = "form-control"
                    id = "lastName"
                    name = "lastName"
                    value = {user.lastName}
                    onChange = {(e) => setUser({...user, lastName: e.currentTarget.value})}
                />
            </div>
            <div className = "my-2" style = {{display:"flex"}}>
                <label htmlFor = "phoneNumber" className = "fw-bold me-3 py-2">Phone:</label>
                <Cleave
                    required
                    placeholder = "Mobile Phone"
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                    className = "form-control"
                    name = "phoneNumber"
                    id = "phoneNumber"
                    options = {{
                        blocks:[3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                    value = {user.phoneNumber}
                    onChange = {(e) => setUser({...user, phoneNumber: e.currentTarget.value})}
                />
            </div>
            <div className = "my-2" style = {{display:"flex", alignItems: "center"}}>
                <label htmlFor = "background" className = "fw-bold me-3">Background:</label>
                <textarea
                    className = "form-control"
                    id = "background"
                    name = "background"
                    value = {user.background}
                    onChange = {(e) => setUser({...user, background: e.currentTarget.value})}
                />
            </div>
            <div className="mt-3">
                <Link children = "Close" className = "btn btn-outline-secondary me-3" to = ".."/>
                <button children = {keyword} className = "btn btn-primary float-end" type = "submit"/>
            </div>
        </Form>
    )
}